import { render, staticRenderFns } from "./ResourcePoolInventory.vue?vue&type=template&id=28e2a893&scoped=true&"
import script from "./ResourcePoolInventory.vue?vue&type=script&lang=js&"
export * from "./ResourcePoolInventory.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePoolInventory.vue?vue&type=style&index=0&id=28e2a893&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2a893",
  null
  
)

export default component.exports